export const WISH_LIST = 'WISH_LIST'
